import * as React from 'react';
import * as Modal from 'react-modal';
import { NoteService } from '../services/noteService';

export default function CreateNewCategoryModal({ closeNewCategoryDialog, onNewCategoryAdded }) {
    const [categoryName, setCategoryName] = React.useState('');
    const isSaveDisabled = !categoryName || categoryName.length === 0;

    const handleCreateCategory = () => {
        if (isSaveDisabled) {
            return;
        }

        const noteService = new NoteService();
        noteService.createCategory(
            { name: categoryName },
            response => { 
                onNewCategoryAdded(response);
            },
            error => {
                console.log(error);
            }
        );
    }

    return (
        <Modal isOpen={true} overlayClassName="modal__overlay" className="modal__window" contentLabel="Lägg till kategori" onRequestClose={closeNewCategoryDialog}>
            <button onClick={closeNewCategoryDialog} className="modal__close">Stäng</button>
            <div className="modal__content">
                <h2 className="modal__title">Lägg till kategori</h2>
                <div className="share-content">
                    <div className="form-field  share-content__form-field">
                        <input type="text" id="categoryName" className="share-content__email" placeholder="Ange ett namn för kategorin" maxLength={50} autoComplete="off" autoFocus value={categoryName} onChange={(event) => setCategoryName(event.target.value)} />
                        <label className="share-content__label" htmlFor="categoryName">Namn på kategori</label>
                    </div>
                </div>
                <div className="">
                    <button className={`button__primary ${(isSaveDisabled ? 'modal__button--disabled' : '')}`} onClick={handleCreateCategory}>Spara</button>
                    <button className="button__secondary" onClick={closeNewCategoryDialog}>Avbryt</button>
                </div>
            </div>
        </Modal>
    )
}
